import type { ItemType, ListType } from '../type';

const baseKey = {
  /**
   * @param domain 관련된 단위 기능을 묶은 상위 그룹 (ex. 고객사)
   * @param subDomains 관련된 단위 기능을 묶은 하위 그룹 리스트 (ex. 고객사의 지점, 매니저 등)
   * @returns <어떤> 도메인을 식별하기 위한 기본 쿼리키
   */
  domainKey(domain: string, subDomains?: (string | number)[]) {
    return subDomains ? [domain, ...subDomains] : [domain];
  },

  /**
   * @param domainKey domainKey 메서드 호출 리턴 값
   * @param listType 리스팅 유형
   * @returns <어떤> 도메인의 <어떤 리스팅 유형>의 리스트 기능에 대한 쿼리키 (ex. 무한 스크롤 방식 고객사 리스트)
   */
  listKey(domainKey: (string | number)[], listType: ListType) {
    return [...domainKey, 'list', listType];
  },

  /**
   * @param domainKey domainKey 메서드 호출 리턴 값
   * @param listType 리스팅 유형
   * @returns <어떤> 도메인의 <어떤 리스팅 유형>의 통계 리스트 기능에 대한 쿼리키 (ex. 전체 정기 작업 통계 리스트)
   */
  statisticsKey(domainKey: (string | number)[], listType: ListType) {
    return [...domainKey, 'statistics', listType];
  },

  /**
   * @param domainKey domainKey 메서드 호출 리턴 값
   * @param itemType 아이템 유형
   * @returns <어떤> 도메인의 <어떤 아이템 유형>의 아이템 기능에 대한 쿼리키 (ex. 정기 작업 상세)
   */
  itemKey(domainKey: (string | number)[], itemType: ItemType) {
    return [...domainKey, itemType];
  },

  /**
   * @param domainKey domainKey 메서드 호출 리턴 값
   * @returns <어떤> 도메인의 아이템 개수에 대한 쿼리키 (ex. 해당 사업자번호를 가지는 고객사 개수)
   */
  countKey(domainKey: (string | number)[]) {
    return [...domainKey, 'count'];
  },

  /**
   * 🔑 API 요청 쿼리 파라미터에 따른 동적 쿼리 키 목록 생성
   * @deprecated 쿼리 파라미터 객체를 배열로 변환한 후 spread 하던 방식에서 객체 그대로 키로 push 하는 방식으로 변경
   */
  // listParamKey(params: ListParams) {
  // 	return Object.entries(params)
  // 		.reduce((arr, [key, value]) => {
  // 			if (value) return arr.concat(`${key}=${value}`);
  // 			return arr;
  // 		}, [] as string[])
  // 		.sort(); // Devtool에서 보기 쉽게 파라미터 유니코드 오름차순 정렬
  // },
};

export default baseKey;
